module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "p9000f1639970001001"
    }
  }), _c('p', {
    staticClass: "halftitle"
  }, [_vm._v("THE KNITTER’S BIBLE")]), _c('p', {
    staticClass: "book-subtitle"
  }, [_vm._v("knitted throws and cushions")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "p9000f1639960002001"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f163g2001.png",
      "width": "90.38113%"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87bc1636","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch001.vue
// module id = 60
// module chunks = 0